if ( typeof SearchForm !== 'function' ) {

	/* ── Header typeahead LEFT column: curated collection manifest ─────────
	   The predictive endpoint returns products only, and Shopify's collection
	   matching can't do substring-anywhere + family synonyms. So the left
	   "Collections" column is a small, curated, client-matched manifest. Every
	   `u` is a live 200 URL (verified 2026-07-09). Keywords carry the routing
	   family synonyms so "dtf" surfaces gang sheet / UV, "shirts" catches
	   Sweatshirts, "gild" → Gildan. Register order (custom products, then blank
	   apparel) is the left-column render order. Edit here to add/retire an
	   entry — keep URLs 200. (Sublimation intentionally omitted: no live
	   transfers-store landing at build time.) */
	var NT_COLLECTIONS = [
		{ t: "DTF Transfers", u: "/products/dtf-transfers", k: ["dtf","direct to film","dtf transfers","transfers","gang sheet"] },
		{ t: "Build a Gang Sheet", u: "/products/build-your-own-gang-sheet", k: ["gang sheet","gang","build a gang","dtf gang","gangsheet","sheet"] },
		{ t: "UV DTF PermaStickers", u: "/products/uv-dtf-stickers-decals-by-size", k: ["uv","uv dtf","uvdtf","permasticker","permastickers","decals"] },
		{ t: "Custom Patches", u: "https://ninjapatches.com/pages/shop-custom-patches", pt: true, k: ["patch","patches","embroidered","chenille","leather patch","woven","pvc","rubber","full color","3d embroidery","faux leather","genuine leather","pvc patches","rubber patches","chenille patches","embroidered patches","woven patches","leather patches","full color patches","3d embroidery patches","3d embroidered patches"] },
		{ t: "Stickers & Decals", u: "/collections/custom-stickers-magnets", k: ["sticker","stickers","decal","decals","magnet","magnets"] },
		{ t: "Specialty Transfers", u: "/collections/specialty-dtf-transfers", k: ["specialty","puff","glitter","spangle","foil","holographic","reflective","metallic","glow"] },
		{ t: "Viral Designs", u: "/collections/viral-designs-for-dtf-transfers", k: ["viral","virals","viral designs","viral dtf","viral transfers","trending designs"] },
		{ t: "T-Shirts", u: "/collections/t-shirts", k: ["shirt","shirts","tee","tees","t shirt","tshirt","t-shirt"] },
		{ t: "Short Sleeve Shirts", u: "/collections/short-sleeve-t-shirts", k: ["short sleeve","shirt","shirts","tee","tees"] },
		{ t: "Long Sleeve Shirts", u: "/collections/long-sleeve-t-shirts", k: ["long sleeve","shirt","shirts","longsleeve"] },
		{ t: "Performance Shirts", u: "/collections/performance-shirts", k: ["performance","moisture","wicking","athletic","dri fit","dry fit","shirt","shirts"] },
		{ t: "Polos", u: "/collections/polos", k: ["polo","polos","polo shirt","polo shirts","golf shirt"] },
		{ t: "Sweatshirts & Hoodies", u: "/collections/sweatshirts", k: ["sweatshirt","sweatshirts","shirts","hoodie","hoodies","crewneck","fleece","pullover"] },
		{ t: "Hats", u: "/collections/hats", k: ["hat","hats","cap","caps","beanie","trucker","headwear","snapback"] },
		{ t: "Quarter Zips", u: "/collections/quarter-zip", k: ["quarter zip","quarter zips","quarter-zip","1/4 zip","pullover","zip"] },
		{ t: "Camo", u: "/collections/camouflage", k: ["camo","camouflage","realtree","hunting"] },
		{ t: "Comfort Colors", u: "/collections/comfort-colors", k: ["comfort colors","comfort","c1717","comfort color"] },
		{ t: "Gildan", u: "/collections/gildan", k: ["gildan","g500","g640","g185","g200","g800"] },
		{ t: "Next Level", u: "/collections/next-level", k: ["next level","nextlevel","n6210","3600"] },
		{ t: "Bella + Canvas", u: "/collections/bella-canvas", k: ["bella","canvas","bella canvas","bella+canvas","3001"] }
	];
	function ntEsc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }
	/* WORD-BOUNDARY match: the term must prefix-match the START of a word in the
	   title or a keyword — NOT a substring-anywhere (which false-matched "red"
	   inside "emb-red-dered"). "shirts" surfaces Sweatshirts via the explicit
	   "shirts" keyword, not a substring of "sweatshirts". A multi-word term also
	   matches a phrase that starts with it (e.g. "long sleeve" → keyword
	   "long sleeve"). */
	function ntMatchCollections(term){
		var q = String(term || '').toLowerCase().replace(/\s+/g,' ').trim();
		if (q.length < 2) return [];
		var out = [];
		for (var i = 0; i < NT_COLLECTIONS.length; i++){
			var c = NT_COLLECTIONS[i];
			var phrases = [c.t.toLowerCase()].concat(c.k);
			var hit = false;
			for (var p = 0; p < phrases.length && !hit; p++){
				var phrase = phrases[p];
				if (phrase.indexOf(q) === 0) { hit = true; break; } // phrase starts with the term
				var words = phrase.split(/[^a-z0-9]+/);
				for (var w = 0; w < words.length; w++){
					if (words[w] && words[w].indexOf(q) === 0) { hit = true; break; } // a WORD starts with the term
				}
			}
			if (hit) out.push(c);
		}
		return out.slice(0, 8);
	}
	/* ── Patch Types (PATCHTYPE2, 2026-09-11) ──────────────────────────────
	   The 8 Ninja Patches patch types come from the ninjaforce public search
	   payload (`router.patchTypes`, ninjaforce PR #2917), NEVER a list typed
	   here. The manifest match on the Custom Patches entry (`pt: true`) is the
	   intent gate; the payload is the data (label, href, image, used verbatim).
	   ninjaforce attaches patchTypes only when ITS router triages the query as
	   patches (queries containing "patch"), and the list changes on deploys,
	   not keystrokes, so it is fetched ONCE per page load with the canonical
	   query and reused for every later patches match (no per-keystroke fetch).
	   Any failure (network, CORS, missing field) renders the dropdown exactly
	   as before: the single "Custom Patches" Related chip. */
	var NT_PATCH_TYPES_URL = 'https://main.dswnj5q837rc8.amplifyapp.com/api/public/search?q=patches';
	var ntPatchTypes = { data: null, pending: null, failedAt: 0 };
	function ntFetchPatchTypes(){
		if ( ntPatchTypes.data ) return Promise.resolve(ntPatchTypes.data);
		if ( ntPatchTypes.pending ) return ntPatchTypes.pending;
		if ( ntPatchTypes.failedAt && (Date.now() - ntPatchTypes.failedAt) < 60000 ) return Promise.resolve(null); // after a failure: one retry per minute at most
		if ( typeof fetch !== 'function' ) return Promise.resolve(null);
		var isUrl = function(u){ return typeof u === 'string' && /^https?:\/\//i.test(u); };
		ntPatchTypes.pending = fetch(NT_PATCH_TYPES_URL, { headers: { 'Accept': 'application/json' }, mode: 'cors', credentials: 'omit' })
			.then(function(r){ return r.ok ? r.json() : null; })
			.then(function(d){
				var router = d && d.router;
				var list = (router && Array.isArray(router.patchTypes)) ? router.patchTypes.filter(function(e){
					return e && typeof e.label === 'string' && e.label && isUrl(e.href);
				}) : [];
				if ( ! list.length ) { ntPatchTypes.failedAt = Date.now(); return null; }
				ntPatchTypes.data = { url: isUrl(router.url) ? router.url : '', types: list };
				return ntPatchTypes.data;
			})
			.catch(function(){ ntPatchTypes.failedAt = Date.now(); return null; })
			.then(function(v){ ntPatchTypes.pending = null; return v; });
		return ntPatchTypes.pending;
	}
	/* Patch Types group markup: reuses the product-tile classes (.nt-ta__p*) so
	   it inherits the tile styling with no new CSS; cross-store links open in a
	   new tab like the existing cross-store Related chips. It REPLACES the
	   Products group (PATCHTYPE3): same slot, same label style, so it carries
	   no .nt-ta__related border. */
	function ntPatchTypesHtml(data){
		var html = '<div class="nt-ta__pt"><div class="nt-ta__label">Patch Types</div>'
			+ '<div class="nt-ta__pt-grid" style="display:grid;grid-template-columns:repeat(auto-fill,minmax(120px,1fr));gap:10px">';
		for ( var i = 0; i < data.types.length; i++ ){
			var e = data.types[i];
			var img = (typeof e.image === 'string' && /^https?:\/\//i.test(e.image)) ? e.image : '';
			html += '<a class="nt-ta__p" data-js-search-item tabindex="-1" href="' + ntEsc(e.href) + '" target="_blank" rel="noopener" title="' + ntEsc(e.label) + '">'
				+ '<span class="nt-ta__p-img">' + ( img ? '<img src="' + ntEsc(img) + '" alt="' + ntEsc(e.label) + '" width="400" height="400" loading="lazy">' : '' ) + '</span>'
				+ '<span class="nt-ta__p-b"><span class="nt-ta__p-t">' + ntEsc(e.label) + '</span></span></a>';
		}
		return html + '</div></div>';
	}
	/* Bold the matched substring within the title (mock treatment); if the match
	   was keyword-only (term not in the title), render the title plain. */
	function ntBoldTitle(title, term){
		var q = String(term || '').trim();
		var i = q ? title.toLowerCase().indexOf(q.toLowerCase()) : -1;
		if (i === -1) return ntEsc(title);
		return ntEsc(title.slice(0, i)) + '<b>' + ntEsc(title.slice(i, i + q.length)) + '</b>' + ntEsc(title.slice(i + q.length));
	}

	/* Product handle from a /products/<handle> URL (for dedupe vs native tiles). */
	function ntHandle(href){
		var m = String(href || '').match(/\/products\/([^/?#]+)/i);
		return m ? m[1].toLowerCase() : '';
	}
	/* Build ONE product tile matching the section's .nt-ta__p markup, from a
	   products.json product. Defensive: missing image → empty img span; no
	   parseable variant price → no price line; USD (this store) formatted "$X.XX",
	   "From " when the price varies. Shopify CDN honors ?width=400 for the tile. */
	function ntProductTile(p){
		if ( ! p || ! p.handle ) return '';
		var url = '/products/' + p.handle;
		var title = p.title || '';
		var imgs = Array.isArray(p.images) ? p.images : [];
		var raw = (imgs.length && imgs[0] && imgs[0].src) ? imgs[0].src : '';
		var img = raw ? raw + (raw.indexOf('?') >= 0 ? '&' : '?') + 'width=400' : '';
		var vs = Array.isArray(p.variants) ? p.variants : [];
		var nums = vs.map(function(v){ return parseFloat(v && v.price); }).filter(function(n){ return !isNaN(n); });
		var priceHtml = '';
		if ( nums.length ){
			var min = Math.min.apply(null, nums), max = Math.max.apply(null, nums);
			priceHtml = '<span class="nt-ta__p-pr">' + (max > min ? 'From ' : '') + '$' + min.toFixed(2) + '</span>';
		}
		var vendor = (p.vendor || '').trim();
		return '<a class="nt-ta__p" data-js-search-item tabindex="-1" href="' + url + '" title="' + ntEsc(title) + '">'
			+ '<span class="nt-ta__p-img">' + ( img ? '<img src="' + ntEsc(img) + '" alt="' + ntEsc(title) + '" width="400" height="400" loading="lazy">' : '' ) + '</span>'
			+ '<span class="nt-ta__p-b">'
			+ '<span class="nt-ta__p-t">' + ntEsc(title) + '</span>'
			+ ( vendor ? '<span class="nt-ta__p-sub">' + ntEsc(vendor) + '</span>' : '' )
			+ priceHtml
			+ '</span></a>';
	}

	/* ── "Guides & Help" content: curated head-query manifest ──────────────
	   Native Shopify predictive matches page/article TITLE tokens, so it's
	   inconsistent on the instructional phrasing customers actually type
	   ("washing instructions" → 0 hits; "how to apply dtf" → misses the main
	   instructions page). So the HEAD instruction/care queries are curated here:
	   a synonym keyword set → the ONE canonical page. The blog/article long-tail
	   rides Shopify's native page,article results (merged + deduped in
	   injectGuides). Canonical URLs pulled from the live pages sitemap (verified
	   200, 2026-07-16). Keep in sync with the pages when handles change; a miss
	   just falls back to the native results, not a broken dropdown. Ordering =
	   render priority (canonical DTF instructions first). */
	var NT_CONTENT = [
		// FAQ lives on the app-proxy page /a/faq (the site nav uses it). The legacy
		// Shopify page /pages/main-faqs still 200s and Shopify native predictive keeps
		// surfacing it, so curate the canonical /a/faq FIRST here + suppress the legacy
		// page in the native loop (NT_CONTENT_SUPPRESS below).
		{ t: "FAQ", u: "/a/faq", k: ["faq","faqs","frequently asked questions","questions","common questions","help center","help"] },
		{ t: "DTF Heat Press Instructions", u: "/pages/heat-press-instructions-for-dtf-transfers", k: ["press","pressing","pressing instructions","heat press","how to press","how to apply dtf","apply dtf","applying dtf","dtf application","how to apply","application","applying","temperature","temp","time","heat setting","settings","dtf instructions","how to use dtf"] },
		{ t: "UV DTF Application Instructions", u: "/pages/uv-dtf-stickers-application-instructions", k: ["uv dtf","uvdtf","uv application","apply uv","applying uv","uv instructions","how to apply uv","permasticker","permastickers","uv sticker"] },
		{ t: "Applying UV DTF 3D PermaStickers", u: "/pages/applying-uv-dtf-3d-permastickers", k: ["3d permasticker","3d sticker","cup wrap","permasticker application"] },
		{ t: "Applying DTF With a Cricut", u: "/pages/applying-dtf-transfers-with-a-cricut", k: ["cricut","easypress","cricut dtf","cricut press","apply with cricut"] },
		{ t: "How to Apply DTF to Hats", u: "/pages/how-to-apply-dtf-transfers-to-hats", k: ["hat","hats","cap","caps","apply to hat","dtf hat","hat press"] },
		{ t: "DTF Care & Maintenance", u: "/pages/dtf-care-maintenance", k: ["care","maintenance","wash","washing","washing instructions","wash instructions","laundry","how to wash","clean","cleaning","care instructions","after washing","maintain"] },
		{ t: "How to Wash Graphic Tees", u: "/pages/how-to-wash-graphic-tees", k: ["wash","washing","wash shirt","wash tee","wash graphic tee","laundry","how to wash"] },
		{ t: "How to Store DTF Transfers", u: "/pages/how-to-store-dtf-transfers", k: ["store","storage","storing","how to store","shelf life","keep dtf","store dtf"] },
		{ t: "DTF Transfer Placement Guide", u: "/pages/dtf-transfer-placement-guide", k: ["placement","where to place","positioning","position","alignment","align","center design","placement guide"] },
		{ t: "How to Pick a Heat Press", u: "/pages/how-to-pick-a-heat-press-machine", k: ["pick a heat press","choose heat press","best heat press","heat press machine","which heat press","buy heat press","heat press for dtf"] }
	];
	/* Legacy Shopify pages superseded by a curated canonical entry above — dropped
	   from the NATIVE page/article results so they never show alongside (or instead
	   of) the canonical page. Keys are normalized pathnames (lowercase, no trailing
	   slash) matching injectGuides' norm(). FAQ: /pages/main-faqs (+ singular) → /a/faq. */
	var NT_CONTENT_SUPPRESS = { "/pages/main-faqs": 1, "/pages/main-faq": 1 };
	/* BIDIRECTIONAL word-boundary match (content queries are typed in FULL, unlike
	   the collections rail which matches a typed prefix): an entry matches when
	   either (1) the QUERY CONTAINS the keyword phrase — "how to apply dtf transfers"
	   contains "how to apply dtf" → the canonical instructions page (the native
	   title-token miss, fixed by curation); or (2) the query is a PREFIX of the
	   keyword — a short prefix like "wash" → "washing". Returns matched canonical
	   pages in register order (canonical first; dedup by URL; cap 6). */
	function ntMatchContent(term){
		var q = String(term || '').toLowerCase().replace(/\s+/g,' ').trim();
		if (q.length < 2) return [];
		var q_pad = ' ' + q + ' ';
		var out = [], seen = {};
		for (var i = 0; i < NT_CONTENT.length; i++){
			var c = NT_CONTENT[i], hit = false;
			for (var p = 0; p < c.k.length && !hit; p++){
				var k = c.k[p];
				if (q_pad.indexOf(' ' + k + ' ') >= 0) { hit = true; break; } // (1) query contains keyword
				if (k.indexOf(q) === 0) { hit = true; break; }                // (2) query is prefix of keyword
			}
			if (hit && !seen[c.u]) { seen[c.u] = true; out.push(c); }
		}
		return out.slice(0, 6);
	}
	/* Relevance guard for NATIVE page/article items: keep only those whose title
	   shares a word (4-char stem, lenient for wash/washing) with the query, so a
	   product query that returns tangential content shows nothing. Empty query
	   words → keep (curated already gated content-intent upstream). */
	function ntContentRelevant(title, term){
		var t = String(title || '').toLowerCase();
		var words = String(term || '').toLowerCase().split(/[^a-z0-9]+/).filter(function(w){ return w.length >= 3; });
		if (!words.length) return true;
		return words.some(function(w){ return t.indexOf(w.slice(0, 4)) >= 0; });
	}

	class SearchForm extends HTMLElement {

		constructor() {

			super();	
			this.cachedResults = {};
			this.collProductsCache = {}; // per-session cache of a matched collection's products.json (keyed by handle)
			this.input = this.querySelector('[data-js-search-input]');
			this.predictiveSearchResults = this.querySelector('[data-js-search-results]');
			this.results = [];
			this.preloader = false;

			if ( KROWN.settings.predictive_search_enabled != "false" ) {

				let inputValue = this.input.value;
				this.input.addEventListener('keyup', debounce(e=>{
					if ( this.input.value != inputValue ) {
						inputValue = this.input.value;
						this.getSearchResults(this.input.value.trim());
					} else if ( this.input.value == '' ) {
						this.clearSearchResults();
					}
				},150));

				this.input.addEventListener('keydown', e=>{
					if ( this.a11yIndex != -1 ) {
						if (
							e.keyCode === window.KEYCODES.UP ||
							e.keyCode === window.KEYCODES.DOWN ||
							e.keyCode === window.KEYCODES.RETURN
						) {
							e.preventDefault();
						}
					}
				});

				this.input.addEventListener('keyup', e=>{
					if (e.keyCode === window.KEYCODES.UP) {
						this.navigateThrough('UP');
						return true;
					}

					if (e.keyCode === window.KEYCODES.DOWN) {
						this.navigateThrough('DOWN');
						return true;
					}

					if (e.keyCode === window.KEYCODES.RETURN) {
						if ( this.a11yIndex != -1 ) {
							document.location.href = this.results[this.a11yIndex].tagName == "A" ? this.results[this.a11yIndex].href : this.results[this.a11yIndex].querySelector('a').href;
						}
					}
				})

				/* (b) Escape closes the typing typeahead. Without this, Escape
				   only native-clears the field, then the debounced keyup re-runs
				   getSearchResults('') → the placeholder re-renders and the panel
				   stays open. Close explicitly: reset + empty results + blur. */
				this.input.addEventListener('keydown', e=>{
					if (e.key === 'Escape' || e.keyCode === 27) {
						e.preventDefault();
						this.input.value = '';
						this.clearSearchResults();
						this.input.blur();
						document.body.classList.remove('search-active');
					}
				});

				/* (c) Focus leaving the whole <search-form> (keyboard tab-away)
				   closes it. Guarded to a REAL relatedTarget outside this element:
				   clicking a result tile blurs with relatedTarget=null, and
				   dismissing there would remove the <a> before its click lands. */
				this.addEventListener('focusout', e=>{
					if (e.relatedTarget && !this.contains(e.relatedTarget)) {
						this.input.value = '';
						this.clearSearchResults();
						document.body.classList.remove('search-active');
					}
				});

			}

		}

		getSearchResults(query="") {

			this.currentQuery = query;
			this.preloadSearchResults();

			const queryKey = query.replace(" ", "-").toLowerCase();
			if (this.cachedResults[queryKey]) {
				this.renderSearchResults(this.cachedResults[queryKey]);
				return;
			}

			this.a11yIndex = -1;

			// Right column = predictive products, capped at exactly 6 (Option A —
			// predictive relevance; best-selling tuning via S&D boosts). resources
			// params limit the render server-side so only 6 come back.
			fetch(`${KROWN.settings.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product,page,article&resources[limit]=6&section_id=helper-predictive-search`)
				.then(response=>{
					if (!response.ok) {
						var error = new Error(response.status);
						this.clearSearchResults();
						throw error;
					}
					return response.text();
				})
				.then(text=>{
					const results = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-helper-predictive-search').innerHTML;
					this.cachedResults[queryKey] = results;
					this.renderSearchResults(results);
				})	
				.catch((e) => {
					throw e;
				}); 

		}

		clearSearchResults(){
			this.predictiveSearchResults.innerHTML = '';
			this.preloader = false;
			this.results = [];
		}

		preloadSearchResults(){
			if ( ! this.preloader ) {
				this.preloader = true;
				this.predictiveSearchResults.innerHTML = KROWN.settings.predictive_search_placeholder;
			}
		}

		renderSearchResults(results){
			this.predictiveSearchResults.innerHTML = results;
			// Two-column typeahead: fill the LEFT "Collections" column from the
			// curated manifest (matched against the current query) + an escape
			// hatch, THEN collect [data-js-search-item] so keyboard nav includes
			// the collection rows (DOM-first) + escape hatch + product tiles.
			this.injectCollections();
			this.injectGuides();
			this.injectCollectionProducts();
			this.preloader = false;
			this.results = this.predictiveSearchResults.querySelectorAll('[data-js-search-item]');
			// Patch Types last: its paint() re-derives this.results (tiles in, hidden
			// Products out) on both the cached (sync) and first-fetch (async) paths.
			this.injectPatchTypes();
		}

		injectCollections(){
			const holder = this.predictiveSearchResults.querySelector('[data-nt-collections]');
			if ( ! holder ) return; // section markup absent (older cache) → skip
			const q = (this.currentQuery || '').trim();
			const matches = ntMatchCollections(q);

			// ── Dedupe left column against the right products (query-agnostic) ──
			// A curated collection whose destination is the SAME on-site page as a
			// rendered product tile is redundant (e.g. "dtf" → left "DTF Transfers"
			// = /products/dtf-transfers duplicates the "DTF Transfers By Size" tile).
			// Compare by PATHNAME only (ignore query/hash/trailing slash). Cross-store
			// (https://…) entries — the Patches link — are kept unconditionally; they
			// can never match an on-site tile.
			const norm = (u) => {
				try { return (new URL(u, location.origin).pathname || '/').replace(/\/+$/, '').toLowerCase() || '/'; }
				catch (e) { return ''; }
			};
			const tilePaths = {};
			this.predictiveSearchResults.querySelectorAll('.nt-ta__p[href]').forEach((a) => { tilePaths[norm(a.getAttribute('href'))] = true; });
			const kept = matches.filter((c) => /^https?:/.test(c.u) || ! tilePaths[norm(c.u)]);

			// ── Split the survivors by URL TYPE (query-agnostic, AFTER dedupe) ──
			//   /collections/*                 → the left "Collections" rail (label
			//                                     now always accurate).
			//   /products/* OR cross-store URL → the "Related" strip below the grid
			//                                     (a product page or an off-site page
			//                                     is not a collection, so labelling it
			//                                     "Collections" reads wrong).
			const isColl = (u) => !/^https?:/i.test(u) && /^\/collections\//i.test(u);
			const collBucket = kept.filter((c) => isColl(c.u));
			const relBucket = kept.filter((c) => !isColl(c.u));

			// Escape hatch — full-width panel footer, present in EVERY state (both /
			// left-only / related-only / neither). Rendered last in the DOM so
			// keyboard nav lands on it after collections → tiles → related chips.
			const foot = this.predictiveSearchResults.querySelector('[data-nt-foot]');
			if ( foot ) {
				// blanks-origin flag: a blanks-branded header (<main-header class="blankmode">)
				// tags the "view all" nav with ctx=blanks so /search first-paints the Blanks header.
				var _ntCtx = (document.getElementById('site-header') && document.getElementById('site-header').classList.contains('blankmode')) ? '&ctx=blanks' : '';
				foot.innerHTML = '<a class="nt-ta__viewall" data-js-search-item tabindex="-1" href="/search?q=' + encodeURIComponent(q) + _ntCtx + '">'
					+ 'Search &quot;' + ntEsc(q) + '&quot; in all products &rarr;</a>';
			}

			// ── Left "Collections" rail ── renders only when its bucket is non-empty;
			// empty → collapse to full-width products. (renderSearchResults rewrites
			// the whole section markup every query, so the two-column default always
			// returns for the next term.) collBucket is always on-site /collections/*,
			// so no target=_blank handling is needed here.
			if ( collBucket.length === 0 ) {
				holder.innerHTML = '';
				this.collapseToProducts();
			} else {
				let html = '';
				for ( let i = 0; i < collBucket.length; i++ ) {
					const c = collBucket[i];
					html += '<a class="nt-ta__cat" data-js-search-item tabindex="-1" href="' + c.u + '">'
						+ '<span class="nt-ta__cat-t">' + ntBoldTitle(c.t, q) + '</span></a>';
				}
				holder.innerHTML = html;
			}

			// ── "Related" strip ── renders only when its bucket is non-empty. Pill-
			// chips per the mock: match-bolding preserved; cross-store chips get the
			// ↗ affordance + keep new-tab (target=_blank), on-site product chips get →.
			// JS injects the styled wrapper only when populated, so an empty bucket
			// leaves no bordered gap.
			const rel = this.predictiveSearchResults.querySelector('[data-nt-related]');
			if ( rel ) {
				if ( relBucket.length === 0 ) {
					rel.innerHTML = '';
				} else {
					let rhtml = '<div class="nt-ta__related"><div class="nt-ta__label">Related</div><div class="nt-ta__rel-row">';
					for ( let i = 0; i < relBucket.length; i++ ) {
						const c = relBucket[i];
						const external = /^https?:/.test(c.u);
						// Patches chip: the payload-carried shop-all URL (router.url) wins over the
						// manifest literal once the Patch Types payload is cached; the literal is
						// the fallback the chip needs when the payload is absent.
						const href = ( c.pt && ntPatchTypes.data && ntPatchTypes.data.url ) ? ntPatchTypes.data.url : c.u;
						rhtml += '<a class="nt-ta__rel-chip" data-js-search-item tabindex="-1" href="' + ntEsc(href) + '"'
							+ ( c.pt ? ' data-nt-pt' : '' )
							+ ( external ? ' target="_blank" rel="noopener"' : '' ) + '>'
							+ '<span class="nt-ta__rel-t">' + ntBoldTitle(c.t, q) + '</span>'
							+ '<span class="nt-ta__rel-arr">' + ( external ? '&#8599;' : '&rarr;' ) + '</span></a>';
					}
					rhtml += '</div></div>';
					rel.innerHTML = rhtml;
				}
			}
		}

		// ── "Guides & Help" section ── content pages/articles for the query.
		// Curated head-query manifest (NT_CONTENT → the ONE canonical page) FIRST,
		// then Shopify's native page,article long-tail (from the hidden
		// [data-nt-native-content] the section renders), deduped by URL vs curated +
		// relevance-guarded. Conditional rule: renders ONLY when there is >=1 item,
		// so product queries (no curated match, native empty) show nothing. Cap 4
		// (CSS hides beyond 2 on mobile). data-js-search-item → keyboard nav.
		injectGuides(){
			const holder = this.predictiveSearchResults.querySelector('[data-nt-guides]');
			if ( ! holder ) return; // section markup absent (older cache) → skip
			const q = (this.currentQuery || '').trim();
			const norm = (u) => {
				try { return (new URL(u, location.origin).pathname || '/').replace(/\/+$/, '').toLowerCase() || '/'; }
				catch (e) { return ''; }
			};
			const items = [], seen = {};
			// 1) curated canonical pages (authoritative, first)
			ntMatchContent(q).forEach((c) => {
				const key = norm(c.u);
				if ( key && ! seen[key] ) { seen[key] = true; items.push({ t: c.t, u: c.u }); }
			});
			// 2) native page/article long-tail, deduped vs curated + relevance-guarded
			const nativeHolder = this.predictiveSearchResults.querySelector('[data-nt-native-content]');
			if ( nativeHolder ) {
				nativeHolder.querySelectorAll('a[href]').forEach((a) => {
					const u = a.getAttribute('href'), t = a.getAttribute('data-title') || '';
					const key = norm(u);
					if ( key && ! seen[key] && ! NT_CONTENT_SUPPRESS[key] && ntContentRelevant(t, q) ) { seen[key] = true; items.push({ t: t, u: u }); }
				});
			}
			// Conditional: no content → render nothing (product queries stay clean).
			if ( items.length === 0 ) { holder.innerHTML = ''; return; }
			let html = '<div class="nt-ta__guides-inner"><div class="nt-ta__label">Guides &amp; Help</div>';
			for ( let i = 0; i < items.length && i < 4; i++ ) {
				html += '<a class="nt-ta__guide" data-js-search-item tabindex="-1" href="' + items[i].u + '">'
					+ '<span class="nt-ta__guide-ic" aria-hidden="true"></span>'
					+ '<span class="nt-ta__guide-t">' + ntBoldTitle(items[i].t, q) + '</span></a>';
			}
			html += '</div>';
			holder.innerHTML = html;
		}

		// Single-column state: hide the left rail and make the grid one column so the
		// product tiles (still capped at 6, 3-across → larger tiles) fill the panel.
		// The escape hatch is NOT relocated here — it lives in the always-present
		// panel footer (see injectCollections). Inline styles only (self-contained;
		// the section markup resets each render).
		collapseToProducts(){
			const grid = this.predictiveSearchResults.querySelector('.nt-ta__grid');
			const left = this.predictiveSearchResults.querySelector('.nt-ta__left');
			if ( left ) left.style.display = 'none';
			if ( grid ) grid.style.gridTemplateColumns = '1fr';
		}

		// ── Fill the Products grid from a matched curated collection ──
		// Native predictive matches product TITLES, so a smart-collection keyword
		// that appears in NO title (e.g. "viral") surfaces the collection tile but
		// an empty grid ("No products match yet"). When a curated /collections/*
		// entry matched, fetch that collection's LIVE products
		// (/collections/<handle>/products.json — public, tracks the smart
		// collection as designs are added) and place them in the grid.
		// NATIVE LEADS: only ADD behind existing native tiles, capped at 6, deduped
		// by handle — so a query native already fills (e.g. "gildan", 6 tiles) is
		// left untouched. Fires ONLY on a match, cached per handle (session), stale-
		// guarded by currentQuery. ANY failure degrades to today's behavior (tile
		// only, grid untouched) — never a broken dropdown.
		injectCollectionProducts(){
			const right = this.predictiveSearchResults.querySelector('.nt-ta__right');
			if ( ! right ) return; // section markup absent (older cache) → skip
			const q = (this.currentQuery || '').trim();
			const matches = ntMatchCollections(q).filter((c) => !/^https?:/i.test(c.u) && /^\/collections\//i.test(c.u));
			if ( ! matches.length ) return; // no curated collection matched → native grid as-is
			const existing = right.querySelectorAll('.nt-ta__prods .nt-ta__p');
			if ( existing.length >= 6 ) return; // native already fills the grid → don't disturb it
			// Handle = the /collections/<handle> segment. (Was .replace(/[/?#].*$/,'')
			// which stripped from the LEADING slash → '' → the method bailed here
			// before ever fetching, so the grid stayed on the empty-state.)
			const hm = String(matches[0].u).match(/\/collections\/([^/?#]+)/i);
			const handle = hm ? hm[1] : '';
			if ( ! handle ) return;

			// Inject the fetched products behind native, deduped, up to the 6 cap.
			const fill = (products) => {
				if ( (this.currentQuery || '').trim() !== q ) return; // a newer keystroke won
				const r2 = this.predictiveSearchResults.querySelector('.nt-ta__right');
				if ( ! r2 || ! Array.isArray(products) || ! products.length ) return;
				if ( r2.querySelector('.nt-ta__pt') ) return; // Patch Types replaced Products → never re-add cards
				const seen = {};
				const nativeTiles = r2.querySelectorAll('.nt-ta__prods .nt-ta__p');
				nativeTiles.forEach((a) => { const h = ntHandle(a.getAttribute('href')); if (h) seen[h] = true; });
				let slots = 6 - nativeTiles.length;
				if ( slots <= 0 ) return;
				let tiles = '';
				for ( let i = 0; i < products.length && slots > 0; i++ ){
					const p = products[i];
					const h = (p && p.handle) ? String(p.handle).toLowerCase() : '';
					if ( ! h || seen[h] ) continue;
					seen[h] = true;
					const t = ntProductTile(p);
					if ( t ) { tiles += t; slots--; }
				}
				if ( ! tiles ) return;
				const prods = r2.querySelector('.nt-ta__prods');
				if ( prods ) {
					prods.insertAdjacentHTML('beforeend', tiles); // native leads; curated fills behind
				} else {
					// native returned 0 → the empty-state is showing → swap in a grid
					const holder = document.createElement('div');
					holder.className = 'nt-ta__prods';
					holder.innerHTML = tiles;
					const empty = r2.querySelector('.nt-ta__empty');
					if ( empty ) { empty.replaceWith(holder); }
					else { r2.insertBefore(holder, r2.querySelector('[data-nt-related]')); }
				}
				// New [data-js-search-item] tiles → refresh the keyboard-nav set.
				this.results = this.predictiveSearchResults.querySelectorAll('[data-js-search-item]');
			};

			const cached = this.collProductsCache[handle];
			if ( cached ) { fill(cached); return; }
			fetch('/collections/' + encodeURIComponent(handle) + '/products.json?limit=6', { headers: { 'Accept': 'application/json' } })
				.then((r) => r.ok ? r.json() : null)
				.then((d) => {
					const products = (d && Array.isArray(d.products)) ? d.products : null;
					if ( ! products ) return; // no data → degrade (grid untouched)
					this.collProductsCache[handle] = products; // cache success (session)
					fill(products);
				})
				.catch(() => { /* degrade gracefully: tile only, native grid untouched */ });
		}

		// ── "Patch Types" group ── (see NT_PATCH_TYPES_URL). Renders ONLY when the
		// Custom Patches manifest entry matched AND the ninjaforce payload carries
		// router.patchTypes. It REPLACES the Products group (PATCHTYPE3): the
		// Products label + grid/empty-state are hidden and the 8 tiles take their
		// slot at the top of the right column; the Related chip, Guides and the
		// footer are untouched. Products are hidden ONLY inside paint(), i.e. only
		// once the tiles are actually there to replace them, so any failure keeps
		// today's dropdown, Products and all. Async on the first match of the
		// session, sync (cached) afterward; a newer keystroke wins. Runs AFTER
		// injectCollectionProducts and uses its own grid class so the 6-tile
		// product cap never counts these.
		injectPatchTypes(){
			const right = this.predictiveSearchResults.querySelector('.nt-ta__right');
			if ( ! right ) return; // section markup absent (older cache) → skip
			const q = (this.currentQuery || '').trim();
			if ( ! ntMatchCollections(q).some((c) => c.pt) ) return; // not a patches query
			const paint = (data) => {
				if ( ! data || (this.currentQuery || '').trim() !== q ) return; // failed, or a newer keystroke won
				const r2 = this.predictiveSearchResults.querySelector('.nt-ta__right');
				if ( ! r2 || r2.querySelector('.nt-ta__pt') ) return;
				// REMOVE the Products group (label + grid or empty-state). Removal, not
				// `hidden`: theme.css sets `.nt-ta__prods { display: grid }`, which beats
				// the [hidden] attribute's UA display:none (the documented [hidden]
				// landmine) — on live the label vanished but the cards stayed. These are
				// the section's own nodes, so the next render restores them for the
				// next term.
				r2.querySelectorAll(':scope > .nt-ta__label, :scope > .nt-ta__prods, :scope > .nt-ta__empty').forEach((n) => { n.remove(); });
				// The column container `.nt-ta__grid` COMPUTES as a content-sized FLEX
				// row on the live page (a later `.sidebar__search-results` rule beats
				// its `display: grid`), so each column is only as wide as its content.
				// The Products grid's three fixed tracks used to give this column its
				// width; with them gone, an auto-fill grid collapses to ONE track
				// (tiles stacked one per row). Grow the column ourselves so the tiles
				// fill the dropdown width — no product node is needed for layout.
				r2.style.flex = '1 1 auto';
				r2.style.minWidth = '0';
				r2.insertAdjacentHTML('afterbegin', ntPatchTypesHtml(data));
				if ( data.url ) r2.querySelectorAll('.nt-ta__rel-chip[data-nt-pt]').forEach((a) => { a.setAttribute('href', data.url); });
				// Refresh the keyboard-nav set: new tiles in, hidden product tiles out.
				this.results = Array.prototype.filter.call(
					this.predictiveSearchResults.querySelectorAll('[data-js-search-item]'),
					(el) => ! el.closest('[hidden]')
				);
			};
			if ( ntPatchTypes.data ) { paint(ntPatchTypes.data); return; }
			ntFetchPatchTypes().then(paint);
		}

		navigateThrough(direction){

			if ( this.a11yIndex == -1 ) {
				this.a11yIndex = 0;
			} else {
				this.results[this.a11yIndex].classList.remove('active');
				if ( direction == 'UP' ) {
					if ( this.a11yIndex - 1 >= -1 ) {
						this.a11yIndex--;
					} 
				} else if ( direction == 'DOWN' ) {
					if ( this.a11yIndex + 1 < this.results.length ) {
						this.a11yIndex++;
					} 
				}
			}

			if ( this.a11yIndex >= 0 ) {
				this.results[this.a11yIndex].classList.add('active');
				document.querySelector('[data-js-search-results-holder]').scrollTop = this.results[this.a11yIndex].offsetTop - 200;
			} else {
				document.querySelector('[data-js-search-results-holder]').scrollTop = 0;
			}

		}

	}

  if ( typeof customElements.get('search-form') == 'undefined' ) {
		customElements.define('search-form', SearchForm);
	}

}

/* (a) Dismiss the typing typeahead on any outside pointer — CAPTURE phase +
   pointerdown so it beats stopPropagation and fires before the click/navigation.
   Replaces the old bubbling `$('body').on('click')`, which any stopPropagation
   between the target and <body> could silently block (the reported "clicking
   elsewhere leaves it open" bug). A pointer INSIDE the search UI — the input,
   the results panel, a result tile, the recents panel, the AI hint, or anywhere
   in <search-form> — is preserved, so tile / row / "view all" / Ask-AI clicks
   still navigate (their click runs after this and we never touch inside targets:
   nothing is cleared, so the <a>/<button> is intact when its click fires). */
function ntInsideSearchUI(t) {
  return !!(t && t.closest && t.closest('search-form, .ninja-search-control, [data-js-search-results], [data-js-search-item], .nt-srch-panel, .nt-srch-ai-hint, .orangeGroupBtn'));
}
function ntDismissTypeahead() {
  document.body.classList.remove('search-active');
  document.querySelectorAll('.ninja-search-control').forEach(function (i) { i.value = ''; });
  document.querySelectorAll('[data-js-search-results]').forEach(function (r) { r.innerHTML = ''; });
}
document.addEventListener('pointerdown', function (e) {
  if (!ntInsideSearchUI(e.target)) ntDismissTypeahead();
}, true);
/* (b) Dismiss when focus enters a cross-origin iframe (the AI-surface on /search).
   A real click INSIDE a cross-origin iframe delivers NO pointerdown to the parent
   document, so the capture-phase handler above never fires over the iframe region
   that fills /search — the panel would stay open (only clearing the text closed
   it). Focusing an iframe DOES blur the top window and set document.activeElement
   to the iframe; that is the reliable dismiss signal (verified firing in-browser).
   The activeElement===IFRAME guard scopes this to iframe focus, not plain tab-away. */
window.addEventListener('blur', function () {
  if (document.activeElement && document.activeElement.tagName === 'IFRAME') ntDismissTypeahead();
});